import { inject } from '@angular/core';
import { BooktechAppService } from './booktech-app.service';
import { MiscUtil } from '../util/misc.util';
import { PriceRule } from '../util/const';
import { FilterPipe } from '../pipes/ngx-filter.pipe';

import { DATAID } from './data.service';
import { BtEvent } from './event.service';
import { EventName } from './tracking.service';

export class OrderService {

  cart:any = {
    items: []
  };

  filter = new FilterPipe();
  constructor(public bas: BooktechAppService ) {
    if(this.bas.envtest) console.log("OrderService.constructor");

   
    this.bas.ds.find(DATAID.LIB_CART, { }, false, true).subscribe((cart:any) => {
      if(this.bas.envtest) console.log(MiscUtil.getLogText("OrderService.cart.then"), MiscUtil.stringify(cart));

      this.cart = cart;
      this.updateCart(false);

    });

    this.bas.ds.getFromStorage(DATAID.LIB_CART, false).then((cart:any) => {
      // if(this.bas.envtest) console.log(MiscUtil.getLogText("OrderService.cart.then"), MiscUtil.stringify(cart));
    });
      

    this.bas.es.on(BtEvent.LibCartAdd, (ev:any) => {
      if(this.bas.envtest) console.log("AppService.CartAdd, ev: ", ev);
      this.cart.items = this.cart.items || [];
      if (ev.clear) this.cart.items = [];
      this.cart.items.push(ev.pw);
      

      this.updateCart(true);

      // this.bas.ts.track(EventName.AddToCart.name)

      // this.bas.ts.track(EventName.AddToCart.name, { //TODO
      //   content_name: ev.pw.product,
      //   content_id: ev.pw.productId,
      //   currency: "NOK",
      //   value: this.cart.sum 
      // });

    
    });

    this.bas.es.on(BtEvent.LibCartEmpty, (ev:any) => {
      this.cart = { };

      this.updateCart(true);
    });
    this.bas.es.on(BtEvent.LibCartRemoveItem, (ev:any) => {
      this.cart.items = this.cart.items.filter((ci:any) => ci.id != ev.item.id);

      this.updateCart(true);
    });

    this.bas.es.on(BtEvent.LibCartSave, (ev:any) => {
      this.cart = ev.cart;

      this.updateCart(true);
    });


  }


  updateCart(save:boolean) {
    let c = this.cart;
    c.items = c.items || [];
    // if (this.bas.envtest) console.log("updateCart, c.items: ", c.items);
    let sum = 0;
    let raSum = 0;
    for (let pw of c.items) {
      sum += pw.calcAmount || pw.amountDouble || pw.totalAmountDouble;
      raSum += pw.retailAmountDouble || 0;

      for (let pi of pw.partItems || []) {
        // sum += pi.amountDouble;
        raSum += pi.retailAmountDouble || 0;
      }
  
      for (let acc of pw.accessories || []) {
        // sum += acc.amountDouble;
        if (!acc.quantity) continue; 
        raSum += acc.retailAmountDouble || 0;
      }

      // for (let acc of pw.accessoriesMandatory || []) {
      //   // sum += acc.amountDouble;
      //   raSum += acc.retailAmountDouble || 0;
      // }
      // for (let acc of pw.accessoriesOptional || []) {
      //   // sum += acc.amountDouble;
      //   raSum += acc.retailAmountDouble || 0;
      // }
      for (let gi of pw.groupItems || []) {
        // sum += gi.amountDouble;
        raSum += gi.retailAmountDouble || 0;
      }

    }
    // if (this.bas.envtest) console.log("updateCart, c.items: ", c.items);
    c.count = c.items.length;
    c.sum = sum;
    c.raSum = raSum;
    // c.items2 = c.items;
    if (this.bas.envtest) console.log("updateCart, c: ", c);
    // if(this.bas.envtest) console.log("AppService.updateCart: ", JSON.stringify(c));

    this.cart =  c;
     
    if (save) this.bas.ds.save(DATAID.LIB_CART, c, false, true);
    // if(this.bas.envtest) console.log("AppService.updateCart: ", c );
    this.bas.es.trigger(BtEvent.LibCartUpdated, { cart: c });
  }

  
  placeOrder(cart:any, extraParams:any, jsonData?:any):Promise<any> {
    
    var user = this.bas.ds.login.user;
    var params:any = { 
      actionType: "appService", 
      action: "placeOrder", 
      acceptEula: true
    };

    if (user) params.userId = user.id;

    MiscUtil.extend(params, extraParams);

    if (jsonData) params.jsonData = JSON.stringify(jsonData);


    MiscUtil.extend(params, MiscUtil.getCartParams(cart)); 

    if (this.bas.envtest) console.log("OrderService.placeOrder: params: ", params);

    return this.bas.ws.json(params, { showLoading: true }).then((json) => {
      if (this.bas.envtest) console.log("OrderService.placeOrder.then, ", json);
      
      if (json.success) {

        

      }

      return json;
    });
  }


  easyPay(id:number, payType:string, extraParams:any = { }):Promise<any> {
    var params:any = { 
      actionType: "order", 
      action: "easyPay", 
      id: id,
      payType: payType,
      url: this.bas.nossr ? location.href : ""
    };

    MiscUtil.extend(params, extraParams);

    if (this.bas.envtest) console.log("OrderService.easyPay: params: ", params);

    return this.bas.ws.json(params, { showLoading: true }).then((json) => {
      if (this.bas.envtest) console.log("OrderService.easyPay.then, ", json);
      
      if (json.success) {

        

      }

      return json;
    });
  }



  updatePwAmount (pw:any) {
    let priceRule = pw.priceRule || "PriceCount";  // PriceCountDaysGuests

    let start = this.bas.ui.dateParseIso(pw.startAsIso8601);
    let end = this.bas.ui.dateParseIso(pw.endAsIso8601);
    
    // if (this.bas.envtest) console.log("OrderService.updatePwAmount start, " + pw.startAsIso8601 + " -> " + start);
    // if (this.bas.envtest) console.log("OrderService.updatePwAmount end, " + pw.endAsIso8601 + " -> " + end);

    let amount = MiscUtil.getPrice(this.bas, priceRule, pw.unitAmount, pw.quantity, 1, start, end, pw.guestCounts?.count); // Setter days til 1 slik at vi ikke regner ut antall dager
    
    if (this.bas.envtest) console.log("OrderService.updatePwAmount, priceRule: " +priceRule+", amount: " + amount + ", pw: ", pw);

    if ((priceRule === PriceRule.PriceCount.name || priceRule === PriceRule.Price.name ) && pw.unitAmountCountMap) {
      // Finn beste match basert på quantity: eks: 1 => 1, 2 => 1, 5 => 5, 6 -> 5 osv
      const quantities = Object.keys(pw.unitAmountCountMap)
          .map(k => parseInt(k, 10))
          .sort((a, b) => a - b);
            
        let bestMatchKey: number | null = null;
        for (const q of quantities) {
          if (q <= pw.quantity) {
            bestMatchKey = q;
          } else {
            break;
          }
        }
        if (this.bas.envtest) console.log("OrderService.updatePwAmount.bestMatchKey: " + bestMatchKey + ", pw: ", pw);
        if (bestMatchKey !== null) {
          amount = pw.unitAmountCountMap[bestMatchKey] / bestMatchKey * pw.quantity / 100.0;
        }


      /*
unitAmountCountMap: {1: 156000, 4: 156000, 5: 195000, 100: 3900000}

      */

    }

    //static getPrice (priceRuleId:number|string, amountDouble:number, quantity:number, days?:number, start?:Date, end?:Date, guests?:number)
   // if (this.bas.envtest) console.log("OrderService.updatePwAmount.amount, " + amount);
    if (amount === undefined) {
      if (this.bas.envtest) console.log("OrderService.updatePwAmount.amount == undeined, pw: ", pw);
      return;
    }
    pw.amountDouble = amount;

  }

  getCart(cart:any = { }) {
    let jc = {
      items: this.getCartItems(cart.items)
    };

    return jc;
  }

  getCartItems(items:any[] = []) {
    // let items:any[] = cart?.items || [];
    return items.map((pw:any) => {
     
      let item:any = this.getPwParams(pw);
      MiscUtil.extend(item, {
        jsonData: pw.jsonData || { }
      })

   
      if (pw.accessories) {
        item.jsonData.accessories = { };
        pw.accessories
        .filter((acc:any) => (!acc.findMandatory || acc.unlimited ) && (acc.quantity || acc.groupItems))
        .map((acc:any) => {
          let jAcc:any = {
            productId: acc.productId,
            quantity: acc.quantity
          }

          if (acc.groupItems) {
            jAcc.quantity = 0;
            jAcc.jsonData = acc.jsonData || { };
            jAcc.jsonData.groupItems = { };
            acc.groupItems.filter((gi:any) => gi.quantity).map((gi:any) => {
              jAcc.jsonData.groupItems[gi.productId] = {
                productId: gi.productId,
                quantity: gi.quantity
              }
            });
          }

          item.jsonData.accessories[acc.productId] = jAcc;
        });
      }

      if (pw.groupItems) {
        item.jsonData.groupItems = { };
        pw.groupItems.filter((gi:any) => gi.quantity).map((gi:any) => {
          item.jsonData.groupItems[gi.productId] = {
            productId: gi.productId,
            quantity: gi.quantity
          }
        });
      }


      return item;
    }); 

  }


  getGroupItemsCount(pw:any):number {
    let count = 0;
    for (let gi of pw?.groupItems || []) {
      count += gi.productObj?.packageProduct ? 1 : (gi.quantity || 0);
    }
    return count;
  }

  validateGroupProduct(pw:any):boolean {
    return !pw?.productObj?.groupProduct || this.getGroupItemsCount(pw) > 0;
  }

  updateAmount(pw:any) {
    let amount = pw.amountDouble;
    for (let acc of pw.accessoriesOptional) {
      amount += acc.amountDouble;
    }

    if (pw.groupItems?.length) {
      for (let gi of pw.groupItems) {
        amount += gi.amountDouble;
      }
    }
    if(this.bas.envtest) console.log("OrderService.updateAmount, setting calcAmount: " + pw.calcAmount + " -> " +  amount);
    pw.calcAmount = amount;
  }


  async getPwData(pw:any, gets:string[], opts:any = { }) {


    var params:any = {
      aType: "order",
      action: "getPwData",
      gets: gets.join(",")
    }

    if (opts?.params) {
      MiscUtil.extend(params, opts?.params)
    }

    MiscUtil.extend(params, this.getPwParams(pw));

    let res = await this.bas.ws.json(params, { });

    let updatedPw = { ...pw };

    if (res.success) {
      // if(this.bas.envtest) console.log("OrderService.getPwAmount, setting pw.amount: " + pw.amount);

      for (let g of gets) {
        switch (g) {
          // case "obj": 

          //   updatedPw = res.pw;
          //   break;
          case "amount": 

            updatedPw.amountInt =  res.amount;
            updatedPw.amount = res.amountAsDouble;
            updatedPw.amountDouble = res.amountAsDouble;
            updatedPw.retailAmountDouble = res.retailAmountAsDouble;
            updatedPw.amountEqualsRetailAmount = updatedPw.amountDouble == updatedPw.retailAmountDouble;
           
            updatedPw.days = res.days;

            if (res.unitAmountGcMap) updatedPw.unitAmountGcMap = res.unitAmountGcMap;
            
            break;

          case "availability": 
        
            updatedPw.available = res.available;
            updatedPw.isAvailable = res.isAvailable;
            updatedPw.isOrderable = res.isOrderable;

            if (updatedPw.isOrderable) updatedPw.errorMsg = ""; // TODO: kan dette lage trøbbel i visse situasjoner? 
   
          break;
          case "timeItemsAvailable": 
    
            updatedPw.timeItemsAvailable = this.mergeTimeItemsAvailable(res.timeItemsAvailable, pw.timeItemsAvailable);
   
            break;
            case "inputValuesList": 
      
              updatedPw.inputValuesList = res.inputValuesList || [];
     
              break;
        }
      }

    }


    if(this.bas.envtest) console.log("OrderService.getPwData, updatedPw: ", updatedPw);

    return updatedPw;

  }

  private mergeTimeItemsAvailable(newTimeItemsAvailable:any, prevTimeItemsAvailable:any): any {
    if (!Array.isArray(newTimeItemsAvailable) || !newTimeItemsAvailable.length) {
      return newTimeItemsAvailable;
    }
    if (!Array.isArray(prevTimeItemsAvailable) || !prevTimeItemsAvailable.length) {
      return newTimeItemsAvailable;
    }

    return newTimeItemsAvailable.map((newTi:any) => {
      if (newTi?.items?.length) {
        return newTi;
      }

      const prevTi = prevTimeItemsAvailable.find((prev:any) => {
        if (prev.timePeriod && newTi.timePeriod && prev.timePeriod === newTi.timePeriod) return true;
        if (prev.label && newTi.label && prev.label === newTi.label) return true;
        if (prev.startTimeAsString && newTi.startTimeAsString && prev.startTimeAsString === newTi.startTimeAsString
            && prev.endTimeAsString && newTi.endTimeAsString && prev.endTimeAsString === newTi.endTimeAsString) return true;
        return false;
      });

      if (prevTi?.items?.length) {
        return { ...newTi, items: prevTi.items };
      }

      return newTi;
    });
  }

  async getPwAmount(pw:any, opts:any = { }) {

    // TODO: avgjøre om vi kan beregen det lokalt eller må spørre serveren. 

    let calcLocal = opts.calcLocal; 

    let unitAmount = pw.unitAmount;

    if (unitAmount === undefined) calcLocal = false; 
    if (pw.quantity === 0) calcLocal = true; 

    let pr = MiscUtil.getPriceRule(pw.priceRule);

    if (pr) {
      if (pr == PriceRule.Price) {
        calcLocal = false; 
      }
    }


    if (calcLocal) {


      let gcs = pw.guestCounts;

      let qty =  pw.quantity != 0 ? (pw.productObj?.guestsIsCount ?  gcs.count : pw.quantitySelected) : 0.0;


      //TODO: sjekke unitAmountGcMap osv-

      // if (pw?.unitAmountGcMap) {
      //   for (let gc = 0; gc < 5; gc++) {
      //     let gcc = r.gcs.map[gc];
      //     if (gcc) {
      //       sum += gcc * pw?.unitAmountGcMap[gc] / 100.0;
      //     }
      //   }
      // } else {
      //   // Finne ut om vi skal gangen med antall pers? 
      //   sum += pw.unitAmount;
      // }

      if (pw.periodArray && pw.periodArray.length == 2) {
        if (typeof pw.periodArray[0] == "string") {
          pw.periodArray[0] = this.bas.ui.dateParseIso(pw.periodArray[0]);
          pw.periodArray[1] = this.bas.ui.dateParseIso(pw.periodArray[1]);
        }
      }

      let amount = MiscUtil.getPrice(this.bas, pw.priceRule, unitAmount, qty, undefined, pw.periodArray?.[0], pw.periodArray?.[1], gcs.count);

      if (amount === undefined) {
        // if(this.bas.envtest) console.log("OrderService.getPwAmount, calcLocal.amount == undefined, setting to false");
        calcLocal = false;
      }
      else {
        // if(this.bas.envtest) console.log("OrderService.getPwAmount, calcLocal: " + amount);
        pw.amount = amount;
      }



    } 
    
    if (!calcLocal) {

      var params:any = {
        aType: "order",
        action: "getPwData",
        gets: "amount,obj"
      }
  
      if (opts?.params) {
        MiscUtil.extend(params, opts?.params)
      }
  
      MiscUtil.extend(params, this.getPwParams(pw));

      let res = await this.bas.ws.json(params, { });

      if (res.success) {
        // if(this.bas.envtest) console.log("OrderService.getPwAmount, setting pw.amount: " + pw.amount);

        pw.amountInt =  res.amount;
        pw.amount = res.amountAsDouble;
        pw.retailAmount =  res.retailAmount;
        pw.retailAmountAsDouble = res.retailAmountAsDouble;

        if (res.inputValuesList) pw.inputValuesList = res.inputValuesList;
        
        if (res.pw) {
          pw.inputValuesList = res.pw.inputValuesList;
        }
      }
 
    }

    if(this.bas.envtest) console.log("OrderService.getPwAmount, p: "+pw.product+ ", q: " + pw.quantity+ ", gcs: "+ pw.guestCounts.guestCountsAsString +", returning pw.amount: " + pw.amount + ", pw: ", pw);

    return pw.amount;

  }
    
  async updatePw(pw:any, opts:any = { }) {


    // let pw = this.pw ;
    if(this.bas.envtest) console.log("OrderService.updatePw, pw.input: ", pw);


    let res:any = undefined;
    if (opts.pwNext ) {
      let pwNext = this.updatePwFromPwValues( opts.pwNext )
      res = { success: true, cart: { items: [ pwNext  ] } } ;
    } else {
      var params:any = {
        aType: "appService",
        action: "getPwCart",
        product: pw.productId
      }
  
      if (opts?.params) {
        MiscUtil.extend(params, opts?.params)
      }
  
      MiscUtil.extend(params, this.getPwParams(pw));
  
      if (opts?.resetParams) {
        for (let k of Object.keys(opts.resetParams)) {
          delete params[k];
        }
        MiscUtil.extend(params, opts.resetParams)
      }
   
      if(this.bas.envtest) console.log("OrderService.updatePw.params: ", params, ", pwParams: ", this.getPwParams(pw), ", opts: ", opts);
    
      res = await this.bas.ws.json(params, { });
    }



    let pwPrev = pw;
    res.prev  = pwPrev;

    if(this.bas.envtest) console.log("OrderService.updatePw.res: ", res);
    if (res.success) {
      // this.cart = res.cart;

  
      pw = opts.pwNext || res.cart.items[0];

      // Sikre at vi alltid jobber på en ny kopi, ikke muterer original-referansen
      if (pw === pwPrev) {
        pw = { ...pw };
      }

      if(this.bas.envtest) console.log("OrderService.updatePw.success.pw: ", pw);
      this.updatePwObj(pw);
      
      this.updatePwFromPrev(pw, pwPrev)


      pw = this.updatePwError(pw);


 
      res.pw = pw;
      return res;
    }

    // Feilmelding
    res.pw = pw;
    return res;
  }


  getPwParams(pw:any) {

    if (!pw) return pw;

    var params:any = {
      product: pw.productId
    }

    if (pw.productObj) {
      let p = pw.productObj;
      let singleDateProduct = (p.tcDate && p.singleDateProduct);
      if (pw.productObj.tcTime || singleDateProduct) {
        if (pw.startDateAsString) params.startDateAsString = pw.startDateAsString;
        if (singleDateProduct) params.endDateAsString = pw.startDateAsString;
        if (pw.productObj.tcTime && pw.timePeriodAsString) params.timePeriodAsString = pw.timePeriodAsString;
        if (!params.startDateAsString && pw.startAsIso8601) params.startAsIso8601 = pw.startAsIso8601;

      } else if (p.periodProduct) {
        if (pw.periodAsRange) params.periodAsRange = pw.periodAsRange;
     
      }
      
      if ((p.findGuestProduct || pw.type == "PACKAGE" ) && pw.guestCounts) params.guestCountsAsString = pw.guestCounts.guestCountsAsString;

      if (p.findIsPriceCustom) params.customAmountDouble = pw.customAmountDouble;

      if (pw.type) {
        params.type = pw.type;
        // if (pw.type == "PROVIDER") params.provider = true;
        // else    if (pw.type == "OVERVIEW") params.overview = true;
      } 

      // if (pw.prid)    params.productRelationId = pw.prid;

     
    } else {

      if (pw.periodAsRange) params.periodAsRange = pw.periodAsRange;
      else if (pw.startAsIso8601) params.startAsIso8601 = pw.startAsIso8601;
      
      if (pw.guestCountsAsString) params.guestCountsAsString = pw.guestCountsAsString;
    }

    // if (this.bas.envtest) console.log("getPwParams, params: ", params);


    if (pw.quantity !== undefined)  params.quantity = pw.quantity;
    if (pw.areaId)  params.area = pw.areaId || "";
    if (pw.prid)  params.productRelationId = pw.prid;

    if (pw.campaignCode)  params.campaignCode = pw.campaignCode;
    // if (pw.jsonData)  params.jsonData = pw.jsonData; // SKal dete være med+



    return params;
  }

  updatePwFromPwValues(pw:any) {

    if (!pw) return pw;

    var params:any = this.getPwParams(pw);
    if (this.bas.envtest) console.log("updatePwFromPwValues, params: ", params);


  }

  updatePwFromPrev(pw:any, pwPrev:any) {

    if (!pw) return pw;
    if (this.bas.envtest) console.log("updatePwFromPrev, pwPrev: ", pwPrev);

    for (let childType of [ "accessories", "groupItems" ] ) {
      if (pwPrev[childType] === undefined) continue; 

      let childMap = MiscUtil.listToMap(pw[childType] || [], "productId"); 
      for (let childPrev of pwPrev[childType] || []) {
        let childNext = childMap[childPrev.productId];
        if (childNext && (childPrev.quantity != childNext?.quantity) ) {
          
          if(this.bas.envtest) console.log("updatePwFromPrev, updating childNext, name: "+childNext.product+": " + childNext.quantity + " -> " + childPrev.quantity);
          if (childNext.copyGuestCounts) {
            childNext.guestCounts = MiscUtil.clone(pw.guestCounts);
            childNext.quantity = pw.guestCounts.count ;
          } else {
            childNext.quantity =  childPrev.quantity;
          }
     
          this.bas.os.updatePwAmount(childNext);
          
        }
      }
    }

        
    if (pw.availablePoolUnits) {
      pw.jsonData = pw.jsonData || { };
      let apu = pw.availablePoolUnits.find((i:any) => i.id == pwPrev.jsonData?.poolUnitId);
      pw.jsonData.poolUnitId = apu?.id || '';
    }


  }


  updatePwObj(pw:any) {
    if (!pw) return pw;

    let prod = pw.productObj;

    this.bas.acs.updateProductObj(prod);

    pw.startDateAsJsDate = this.bas.ui.stringToDate(pw.startDateAsString);
    pw.endDateAsJsDate = this.bas.ui.stringToDate(pw.endDateAsString);
    pw.periodArray =[  pw.startDateAsJsDate,  pw.endDateAsJsDate ]



    if (pw.availablePoolUnits) {
      pw.jsonData = pw.jsonData || { };
      pw.jsonData.poolUnitId = '';
    }


      
    for (let gcIdx in pw.guestCategories) {
      if (pw.guestCounts.map[gcIdx] === undefined) pw.guestCounts.map[gcIdx] = 0; 
    }




    return pw;
  }


  updatePwError(pw:any) {
    let ui = this.bas.ui;
    let prod = pw.productObj;
		
    let errorMsg = "";

    if (pw) {
      let isAdmin = pw.type == "OVERVIEW" || pw.type == "PROVIDER";
      let isRoot = !pw.isChild;

      if (    !pw.isOrderable 
          && !prod.pcRoute
          //&& (!prod.pcGroup || 
          && prod.availabilityInfo
          && prod.findTypeExperience 
          && pw.selectableDatesNext !== undefined 
          && pw.selectableDatesNext.length == 0
          
          ) {
            errorMsg = ui.actrans("web.servlet.json.updatePrice.soldOut"); 
            pw.isSoldOut = true;
          
  
      } else if (isRoot && pw.isStartBeforeStartDateThresholdMin && !isAdmin) errorMsg = ui.actrans("web.servlet.json.updatePrice.startDateThresholdMin", [pw.startDateThresholdMin]);
      else if (isRoot && pw.isStartAfterStartDateThresholdMax && !isAdmin) errorMsg = ui.actrans("web.servlet.json.updatePrice.startDateThresholdMax", [pw.startDateThresholdMax]);
      else if (isRoot && pw.isGuestCountLessThenMin) errorMsg = ui.actrans("web.servlet.json.updatePrice.guestCountLessThenMin", [prod.findMinGuests]);
      else if (isRoot && pw.isGuestCountMoreThenMax) errorMsg = ui.actrans("web.servlet.json.updatePrice.guestCountMoreThenMax", [prod.findMaxGuests]);
      else if (prod.timeProduct && !prod.hasTimes) errorMsg = ui.actrans("web.servlet.json.updatePrice.noTimeAvailable"); 
      else if ( !pw.isOrderable ) { // && !isAdmin
        errorMsg = ui.actrans("web.servlet.json.updatePrice.notAvailable"); 
              
      }
      else if (pw.canBeOrdered !== undefined && !pw.canBeOrdered) {
        errorMsg = ui.actrans("web.servlet.json.updatePrice.notAvailable"); 
        
      }
//				else if (!pw.isOrderable) errorMsg = ui.actrans("web.servlet.json.updatePrice.notAvailable"); 
      

      
      if (errorMsg == "" && !prod.timeProduct) {
        
        if (prod.findTypeLodging && pw.guestCounts.count > pw.cap) errorMsg = ui.actrans("web.servlet.json.updatePrice.cap");
        else if (!isAdmin && pw.isLessThenMinDaysBooking) errorMsg = ui.actrans("web.servlet.json.updatePrice.lessThenMinDaysBooking", [pw.minDaysBooking]);
        else if (!isAdmin && pw.isMoreThenMaxDaysBooking) errorMsg = ui.actrans("web.servlet.json.updatePrice.moreThenMaxDaysBooking", [pw.maxDaysBooking]);
        else if (pw.totalAmount === "") errorMsg = ui.actrans("web.servlet.json.updatePrice.priceIsNull");
        
      }

      if (errorMsg == "" && pw.findMkError != "") errorMsg = pw.findMkError;
    } 
    else {
      pw = { }
    }
    // errorMsg = ui.actrans("web.servlet.json.updatePrice.priceIsNull");
    

    
    if (errorMsg == "NULL") errorMsg = "";
    
    // if (errorMsg != "" && !p.availabilityInfo && aiContainer.length) errorMsg = "";
    
    pw.errorMsg = errorMsg;
    if (errorMsg != "") {

    }
    return pw;
  }


  //

  updateProducts():Promise<any> {

    return this.bas.ds.getFromJson(DATAID.ORDER_PRODUCTS, { actionType: "appService", action: "getProducts" }, true).then((json) => {
      if(this.bas.envtest) console.log("OrderService, updateProducts.then: ", json);
    });


  }

  getProducts(productType?:string):any[] {
    let products = this.bas.ds.getValue(DATAID.ORDER_PRODUCTS, { products: []}).products;
    if (!productType) return products; 

    return this.filter.transform(products, 
      { typeObj: { ptid: productType }}
    );

  }

  getProduct(id:number):any {
    let list:any[] = this.filter.transform(this.getProducts(), 
      { id: id }
    );
    return list.length ? list[0] : undefined;
  }

  getProductInfo(id:any):Promise<any> {
    return this.bas.ws.json({ actionType: "appService", action: "getProduct", id: id }).then((json) => {
     
      return json.product;
    });
  }



  updateUserOrders(coreData = false):Promise<any> {

    return this.bas.ds.getFromJson(DATAID.ORDER_ORDERS, { actionType: "appService", action: "getOrders", userOrders: true, coreData: coreData }, true).then((json) => {
      // if(this.bas.envtest) console.log("OrderService, updateUserOrders.then: ", json);

      // this.ws.ds.saveData
    });
  }

  getUserOrders(productType?:string, coreData = false):any[] {
    let orders = this.bas.ds.getValue(DATAID.ORDER_ORDERS, { orders: []}).orders || [];
    if (!productType) return orders; 

    // if(this.bas.envtest) console.log("OrderService.getOrders: " + orders.length + ", productType: " + productType);


    let transformObj = coreData
      ?  { product: { typeObj: { ptid: productType }} }
      :  { item0: { productObj: { typeObj: { ptid: productType }} } };


    let result = this.filter.transform(orders, transformObj );
    // if(this.bas.envtest) console.log("OrderService.getOrders: " + orders.length + "; result: " + result.length);
    return result;
  }

  getOrder(orderId:any, params:any = { }):Promise<any> {

    MiscUtil.extend(params, { actionType: "appService", action: "getOrder", id: orderId });
    return this.bas.ws.json(params).then((json) => {
     
      return json;
    });
  }


  changeOrder(biid:any, pw:any, extraParams:any, jsonData?:any, coreData = false):Promise<any> {
    
    // var user = this.ws.ds.get(DATAIDS.APP_LOGIN).user;
    var params:any = { 
      actionType: "appService", 
      action: "changeOrder", 
      // acceptEula: true,
      // userId: user.id
      biid: biid
    };

    MiscUtil.extend(params, extraParams);

    if (jsonData) params.jsonData = JSON.stringify(jsonData);


    MiscUtil.extend(params, {
      startAsIso8601: pw.startAsIso8601,
      endAsIso8601: pw.endAsIso8601
    }); 

    if(this.bas.envtest) console.log("OrderService.changeOrder: params: ", params);

    return this.bas.ws.json(params, { showLoading: true }).then((json:any) => {
      if(this.bas.envtest) console.log("OrderService.changeOrder.then, ", json);
      
      if (json.success) {
        return this.updateUserOrders(coreData);
      }
      return json;
    });
  }

  getPwCart(paramsInput:any, onSuccess?:any):Promise<any> {

    var params = { 
      actionType: "appService", 
      action: "getPwCart",
      // product: this.pw.productId,
      // startAsIso8601: this.pw.startAsIso8601, //this.ws.m(this.start).local().format(ISO8601woZ),
      // endAsIso8601: this.pw.endAsIso8601 //this.ws.m(this.end).local().format(ISO8601woZ)
    }
    MiscUtil.extend(params, paramsInput);

    return this.bas.ws.json(params).then((json) => {
      if(this.bas.envtest) console.log("OrderService.getPwCart.then, ");
      
      if (json.success) {
        
        let pw = json.cart.items[0];
        if (onSuccess) onSuccess(pw);
      }

    });

  }


  updateUser(paramsInput:any, onSuccess?:any):Promise<any> {
    var appLogin = this.bas.appLogin;
    
    var params:any = { 
      actionType: "app", 
      action: "updateUser",
    };
    for (let field in paramsInput) {
      params["user_" + field] = paramsInput[field];
      appLogin.user[field] = paramsInput[field];
    };

    // this.bas.ds.save(DATAID.APP_LOGIN, al); //TODO

    return this.bas.ws.json(params).then((json) => {
      if(this.bas.envtest) console.log("OrderService.updateUser.then");
      
      if (json.success) {
        if (onSuccess) onSuccess(json.user);
      }

      return json.user;

    });

  }


  checkIn(order:any, checkIn = true):Promise<any> {
    var appLogin = this.bas.appLogin;
    
    var params:any = { 
      actionType: "appService", 
      action: checkIn ? "checkIn" : "checkOut",
      id: order.id
    };

    return this.bas.ws.json(params).then((json) => {
      if(this.bas.envtest) console.log("OrderService.checkIn.then");
      
      if (json.success) {
        this.updateUserOrders();
      }

      return json.booking;
    });

  }



}
